<template>
  <div class="clip-editor">
    <div class="video-container">
      <video ref="videoElement" controls @timeupdate="onTimeUpdate">
        <source :src="currentVideo.src" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      <img v-if="showImage" :src="currentImage.src" class="overlay-image" />
    </div>
    <div class="controls">
      <button @click="play">Play</button>
      <button @click="pause">Pause</button>
      <button @click="nextClip">Next Clip</button>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'

const videoElement = ref(null)
const currentClipIndex = ref(0)
const showImage = ref(false)

const clips = reactive([
  { type: 'video', src: 'https://digital-human-1323112199.cos.ap-guangzhou.myqcloud.com/ai-virtual-man/system/20240508/20240508154608544841592299525.mp4', duration: 10 },
  { type: 'image', src: 'https://digital-human-1323112199.cos.ap-guangzhou.myqcloud.com/ai-virtual-man/806b3fa03e48a03f2da720ca1d36d240/20240508/544744538845189.png', duration: 5 },
  { type: 'video', src: 'https://videomaker-resources.ivh.qq.com/broadcast/Basic/video/07e0e6880d0d45f1bff18ce3c72f3def.mp4', duration: 15 }
])

const currentVideo = ref(clips[currentClipIndex.value])
const currentImage = ref(clips[currentClipIndex.value])

const play = () => {
  if (currentVideo.value.type === 'video') {
    videoElement.value.play()
  } else {
    showImage.value = true
    setTimeout(nextClip, currentImage.value.duration * 1000)
  }
}

const pause = () => {
  if (currentVideo.value.type === 'video') {
    videoElement.value.pause()
  }
}

const nextClip = () => {
  if (currentClipIndex.value < clips.length - 1) {
    currentClipIndex.value++
    if (clips[currentClipIndex.value].type === 'video') {
      currentVideo.value = clips[currentClipIndex.value]
      showImage.value = false
      videoElement.value.load()
    } else {
      currentImage.value = clips[currentClipIndex.value]
      showImage.value = true
      setTimeout(nextClip, currentImage.value.duration * 1000)
    }
  } else {
    console.log('End of clips')
  }
}

const onTimeUpdate = () => {
  if (videoElement.value.currentTime >= currentVideo.value.duration) {
    videoElement.value.pause()
    nextClip()
  }
}
</script>

<style scoped>
.clip-editor {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-container {
  position: relative;
  width: 640px;
  height: 360px;
  background-color: black;
}

.overlay-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.controls {
  margin-top: 20px;
}

button {
  margin: 0 10px;
  padding: 10px 20px;
  font-size: 16px;
}
</style>
